(function() {
  'use strict';

  function whenThemeReady(callback) {
    if (window.theme && window.theme.Flickity) {
      callback();
      return;
    }

    let attempts = 0;
    const timer = setInterval(function() {
      attempts += 1;
      if (window.theme && window.theme.Flickity) {
        clearInterval(timer);
        callback();
      } else if (attempts > 50) {
        clearInterval(timer);
        console.error('Product in use: theme.Flickity is not available.');
      }
    }, 100);
  }

  function initModalVideoPlayerWithHLS(sectionElement) {
    const section = sectionElement;
    if (!section) return;

    const videoWrappers = section.querySelectorAll('.video_selector');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video) return;
      
      // Always check for and remove duplicate poster wrappers
      const existingPosters = wrapper.querySelectorAll('.custom-poster-wrapper');
      existingPosters.forEach(poster => {
        if (poster.parentNode) {
          poster.remove();
        }
      });
      
      // Also check if video already has a poster wrapper reference
      if (video._posterWrapper && video._posterWrapper.parentNode) {
        video._posterWrapper.remove();
        video._posterWrapper = null;
      }
      
      // Only initialize if not already initialized
      if (video.dataset.initialized === 'true') return;

      const existingSources = video.querySelectorAll('source');
      existingSources.forEach(s => s.remove());
      video.removeAttribute('src');

      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const muteBtn = wrapper.querySelector('.glb_mute');
      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;
      
      // Poster layer
      const posterUrl = getPoster();
      
      let posterWrapper = null;
      if (posterUrl && posterUrl.trim() !== '') {
        posterWrapper = document.createElement('picture');
        posterWrapper.className = 'custom-poster-wrapper';
        Object.assign(posterWrapper.style, {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1,
          background: `url('${posterUrl}') center center / cover no-repeat`,
          pointerEvents: 'none',
          transition: 'opacity 0.4s ease',
          opacity: 1
        });

        wrapper.style.position = 'relative';
        wrapper.appendChild(posterWrapper);
        video._posterWrapper = posterWrapper;
      }

      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = false;
      if (muteBtn) {
        muteBtn.classList.remove('muted');
      }

      function safePlay() {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              if (video._posterWrapper) video._posterWrapper.style.opacity = 0;
            })
            .catch(() => {
              if (video._posterWrapper) video._posterWrapper.style.opacity = 1;
            });
        }
      }
      
      const modalId = section.querySelector('[id^="videoModal"]')?.id || 'videoModal';
      const progressBar = section.querySelector('#' + modalId + ' .progress-bar') || section.querySelector('.video-modal .progress-bar');

      if (progressBar) {
        video.addEventListener('timeupdate', () => {
          if (video.duration) {
            const progressPercent = (video.currentTime / video.duration) * 100;
            progressBar.style.width = progressPercent + "%";
          }
        });
      }
      
      function loadVideo() {
        const src = getSrc();
        if (!src) return;

        var autoplay = shouldAutoplay();
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } else {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            });
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        if (autoplay) { 
          safePlay();
          video.onended = () => {
            const activeItem = section.querySelector('.product_in_use_slider_item.active');
            if (!activeItem) return;
            const currentThumb = activeItem.querySelector('.video-thumb');
            if (!currentThumb) return;
            const thumbs = [...section.querySelectorAll('.video-thumb')];
            const currentIndex = thumbs.indexOf(currentThumb);

            // pick next (or loop to first)
            let nextThumb = thumbs[currentIndex + 1] || thumbs[0];
            // update active class
            section.querySelectorAll('.product_in_use_slider_item.active').forEach(item => item.classList.remove('active'));
            nextThumb.closest('.product_in_use_slider_item')?.classList.add('active');
            // trigger click on next thumb
            nextThumb.click();
          };
        }
      }
      loadVideo();

      if (muteBtn && !muteBtn.dataset.listenerAttached) {
        muteBtn.style.display = 'block';
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
        muteBtn.dataset.listenerAttached = "true";
      }
    });
  }

  function bindModalHandlers(section) {
    if (section.dataset.modalBound === 'true') return;
    section.dataset.modalBound = 'true';

    section.querySelectorAll('.video-thumb').forEach(thumb => {
      if (thumb.dataset.listenerAttached === 'true') return;
      thumb.dataset.listenerAttached = 'true';

      thumb.addEventListener('click', () => {
        const src = thumb.dataset.videoSrc;
        const poster = thumb.dataset.poster;
        if (!src) return;

        const modalId = section.querySelector('[id^="videoModal"]')?.id || 'videoModal';
        const modal = section.querySelector('#' + modalId) || section.querySelector('.video-modal');
        if (!modal) return;

        const video = modal.querySelector('video');
        if (!video) return;

        video.pause();
        if (video.hlsInstance) {
          video.hlsInstance.destroy();
          video.hlsInstance = null;
        }
        video.removeAttribute('src');
        video.load();

        const existingSources = video.querySelectorAll('source');
        existingSources.forEach(s => s.remove());

        video.dataset.desktopVideo = src;
        video.dataset.mobileVideo = src;
        video.dataset.desktopPoster = poster || '';
        video.dataset.mobilePoster = poster || '';
        video.dataset.autoplay = 'true';
        video.dataset.autoplayM = 'true';
        video.dataset.mute = 'true';
        video.dataset.muteM = 'true';
        video.removeAttribute('data-initialized');

        modal.classList.add('open');

        const titleEl = modal.querySelector('.title_and_btns h2');
        if (titleEl) {
          titleEl.textContent = thumb.dataset.title || '';
        }

        const progressBar = modal.querySelector('.progress-bar');
        if (progressBar) {
          progressBar.style.width = '0%';
        }

        const parentItem = thumb.closest('.product_in_use_slider_item');
        if (parentItem) {
          section.querySelectorAll('.product_in_use_slider_item').forEach(el => el.classList.remove('active'));
          parentItem.classList.add('active');
        }

        initModalVideoPlayerWithHLS(section);
      });
    });

    function showNext() {
      const activeItem = section.querySelector('.product_in_use_slider_item.active');
      if (!activeItem) return;

      const currentThumb = activeItem.querySelector('.video-thumb');
      if (!currentThumb) return;

      const thumbs = [...section.querySelectorAll('.video-thumb')];
      const currentIndex = thumbs.indexOf(currentThumb);
      const nextThumb = thumbs[currentIndex + 1] || thumbs[0];

      section.querySelectorAll('.product_in_use_slider_item.active')
        .forEach(item => item.classList.remove('active'));
      nextThumb.closest('.product_in_use_slider_item')?.classList.add('active');
      nextThumb.click();
    }

    function showPrev() {
      const activeItem = section.querySelector('.product_in_use_slider_item.active');
      if (!activeItem) return;

      const currentThumb = activeItem.querySelector('.video-thumb');
      if (!currentThumb) return;

      const thumbs = [...section.querySelectorAll('.video-thumb')];
      const currentIndex = thumbs.indexOf(currentThumb);
      const prevThumb = thumbs[currentIndex - 1] || thumbs[thumbs.length - 1];

      section.querySelectorAll('.product_in_use_slider_item.active')
        .forEach(item => item.classList.remove('active'));
      prevThumb.closest('.product_in_use_slider_item')?.classList.add('active');
      prevThumb.click();
    }

    const nextBtn = section.querySelector('.glb_next');
    const prevBtn = section.querySelector('.glb_prev');

    if (nextBtn && !nextBtn.dataset.listenerAttached) {
      nextBtn.dataset.listenerAttached = 'true';
      nextBtn.addEventListener('click', showNext);
    }

    if (prevBtn && !prevBtn.dataset.listenerAttached) {
      prevBtn.dataset.listenerAttached = 'true';
      prevBtn.addEventListener('click', showPrev);
    }

    const modalId = section.querySelector('[id^="videoModal"]')?.id || 'videoModal';
    section.querySelectorAll('#' + modalId + ' .modal-close, #' + modalId + ' .modal-overlay').forEach(el => {
      if (el.dataset.listenerAttached === 'true') return;
      el.dataset.listenerAttached = 'true';

      el.addEventListener('click', () => {
        const modal = section.querySelector('#' + modalId) || section.querySelector('.video-modal');
        const video = modal?.querySelector('video');
        if (video) {
          video.pause();
          if (video.hlsInstance) {
            video.hlsInstance.destroy();
            video.hlsInstance = null;
          }
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(s => s.remove());
          video.load();
          video.removeAttribute('data-initialized');
        }
        modal?.classList.remove('open');
      });
    });
  }

  function initProductInUseSlider(section) {
    if (!section) return;

    const slider = section.querySelector('.product_in_use_slider');
    if (!slider) return;

    bindModalHandlers(section);

    if (slider.dataset.flickityInitialized === 'true') {
      return;
    }

    const desktop = parseFloat(slider.dataset.desktop) || 5.5;
    const tablet = parseFloat(slider.dataset.tablet) || 4.5;
    const mobile = parseFloat(slider.dataset.mobile) || 2.5;

    function getSlidesToShow() {
      if (window.innerWidth >= 1024) return desktop;
      if (window.innerWidth >= 768) return tablet;
      return mobile;
    }

    const totalSlides = slider.querySelectorAll('.product_in_use_slider_item').length;
    if (totalSlides === 0) return;

    const slidesToShow = getSlidesToShow();
    const canLoop = totalSlides > 1;
    const showArrows = canLoop;

    const flickityOptions = {
      cellSelector: '.product_in_use_slider_item',
      cellAlign: 'left',
      contain: false,
      wrapAround: canLoop,
      autoPlay: false,
      prevNextButtons: showArrows,
      pageDots: false,
      draggable: canLoop,
      touchVerticalScroll: false,
      imagesLoaded: true,
      adaptiveHeight: false,
      setGallerySize: true,
      percentPosition: false,
      dragThreshold: 10,
      friction: 0.8,
      selectedAttraction: 0.14,
      freeScroll: false,
      initialIndex: 0,
      rightToLeft: document.documentElement.getAttribute('dir') === 'rtl'
    };

    try {
      const flickityInstance = new window.theme.Flickity(slider, flickityOptions);
      slider.dataset.flickityInitialized = 'true';
      slider.flickityInstance = flickityInstance;

      const progressBar = section.querySelector('.product_in_use_progress-bar');

      function updateProgressBar() {
        if (!progressBar) return;

        const visibleSlides = getSlidesToShow();
        const thumbWidth = Math.min(100, Math.max(18, (visibleSlides / totalSlides) * 100));
        const maxOffset = Math.max(0, 100 - thumbWidth);
        const normalizedIndex = ((flickityInstance.selectedIndex % totalSlides) + totalSlides) % totalSlides;
        const maxIndex = Math.max(1, totalSlides - 1);
        const offset = (normalizedIndex / maxIndex) * maxOffset;

        progressBar.style.width = thumbWidth + '%';
        progressBar.style.left = offset + '%';
      }

      function moveArrowsToHeader() {
        const arrowsContainer = section.querySelector('.product_in_use_arrows');
        const prevButton = slider.querySelector('.flickity-prev-next-button.previous');
        const nextButton = slider.querySelector('.flickity-prev-next-button.next');

        if (arrowsContainer && prevButton && nextButton && !arrowsContainer.contains(prevButton)) {
          arrowsContainer.appendChild(prevButton);
          arrowsContainer.appendChild(nextButton);
        }
      }

      flickityInstance.on('ready', function() {
        moveArrowsToHeader();
        flickityInstance.resize();
        updateProgressBar();
      });

      flickityInstance.on('select', updateProgressBar);
      flickityInstance.on('scroll', updateProgressBar);

      setTimeout(function() {
        moveArrowsToHeader();
        flickityInstance.resize();
        updateProgressBar();
      }, 200);

      if (window.theme.debounce) {
        window.addEventListener('resize', window.theme.debounce(function() {
          flickityInstance.resize();
          updateProgressBar();
        }, 300));
      }
    } catch (e) {
      console.error('Error initializing product-in-use slider:', e);
    }
  }

  function initAll() {
    document.querySelectorAll('.product_in_use').forEach(section => {
      initProductInUseSlider(section);
    });
  }

  whenThemeReady(initAll);

  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.product_in_use');
    if (section) {
      whenThemeReady(function() {
        initProductInUseSlider(section);
      });
    }
  });

  document.addEventListener('page:loaded', function() {
    whenThemeReady(initAll);
  });

})();
